import React, { useEffect, useState } from "react";
import {Box, Heading, HStack,} from "@chakra-ui/react";
import { Session } from "types/session";
import {sub} from "date-fns";
import { fetchSessions } from "api/webservice/sessions";
import { SessionCard } from "components";
import { filterPastSessions} from "utils/session";

const PastSessions: React.FC = () => {
  const [sessions, setSessions] = useState<Session[]>([]);
  const [pastSessions, setPastSessions] = useState<Session[]>([]);

  const handleFetchSessions = (): void => {
    const filter: any = {
      id: 'start_time_range',
      value: JSON.stringify([sub(new Date(), { days: 7 }), new Date()])
    };
    fetchSessions(0, 10, true, ["start_time", "DESC"], [filter]).then((response: any) => {
      if (response) {
        setSessions(response.entries);
      }
    });
  };
  useEffect(handleFetchSessions, []);

  useEffect(
    () => {
      setPastSessions(filterPastSessions(sessions));
    }
    , [sessions])
  return (
      <>
          {pastSessions.length > 0 && (
              <Box width="95%" p={{ base: 4, md: 0 }}>
                <Heading size="lg" mb={8}>
                  Recent
                </Heading>
                <HStack alignItems="center" spacing={8}>
                  {pastSessions.slice(0, 2).map(session => (
                    <SessionCard session={session} key={session.id} />
                  ))}
                </HStack>
              </Box>
            )}
      </>
  );
}

export default PastSessions;
